import React, { ReactNode, Ref } from "react"
import { TooltipIcon } from "../TooltipIcon"
import { RegisterOptions, UseFormRegister } from "react-hook-form"
import { Container, Description, ErrorMessageInfo, Field, Label } from "./Input.styled"

type TypeInput = {
  placeholder?: string
  label?: string | ReactNode
  name: string
  type?: string
  // eslint-disable-next-line
  errors?: any
  // eslint-disable-next-line
  onChange?: any
  ref?: Ref<HTMLInputElement>
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  disabled?: boolean
  defaultValue?: string | number
  errorType?: string
  description?: string
  removePaddingBottom?: boolean
  // eslint-disable-next-line
  value?: any
  toolTip?: string
  accept?: string
  autoComplete?: string
  min?: string | number
  max?: string | number
  // eslint-disable-next-line
  register?: UseFormRegister<any>
  // eslint-disable-next-line
  validation?: RegisterOptions<any, string> | undefined
}

const Input: React.FC<TypeInput> = React.forwardRef<
  HTMLInputElement,
  React.PropsWithChildren<TypeInput>
>(
  (
    {
      type,
      name,
      placeholder,
      description,
      label,
      errors,
      onChange,
      defaultValue,
      disabled,
      removePaddingBottom = false,
      value,
      toolTip,
      min,
      register,
      validation,
      ...props
    },
    ref
  ) => {
    const error = name.split(".").reduce((obj, key) => obj?.[key], errors)

    const isDisabled = () => {
      if (disabled) return disabled
      return false
    }

    const inputId = `input-${name}`

    return (
      <Container $removePaddingBottom={removePaddingBottom}>
        {label && (
          <Label htmlFor={inputId}>
            {label}
            {toolTip && <TooltipIcon content={toolTip} />}
            <ErrorMessageInfo $show={error}>- {error?.message}</ErrorMessageInfo>
          </Label>
        )}

        {register ? (
          <Field
            id={inputId}
            {...register(name, validation ?? validation)}
            disabled={isDisabled()}
            defaultValue={defaultValue}
            placeholder={placeholder}
          />
        ) : (
          <Field
            id={inputId}
            ref={ref}
            type={type || "text"}
            placeholder={placeholder}
            $invalid={error}
            defaultValue={defaultValue}
            onChange={(e) => onChange(e)}
            disabled={isDisabled()}
            onWheelCapture={(e) => e.currentTarget.blur()}
            value={value}
            min={min}
            {...props}
          />
        )}
        {description && <Description>{description}</Description>}
      </Container>
    )
  }
)

Input.displayName = "Input"

export default Input
